import { IWatch } from "../watches/adminWatches";
import AdminCard from "../../../core/admin/adminCard";
import AdminTable from "../../../core/admin/adminTable";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { AdminCount } from "../../../core/admin/adminBadge";

export default function HiddenWatches({ watches }: { watches: IWatch[] }) {

    return (
        <AdminCard title={<>Escondidos <AdminCount count={watches.length} /></>} description="Relógios retirados do site. Não aparecem para os compradores." bodyClassName="p-3 md:p-4">
            {
                watches.length ?
                    <AdminTable
                        rows={watches}
                        rowKey={(w, idx) => w.id || idx}
                        columns={[
                            { header: "Relógio", mobile: "title", desktopHidden: true, render: w => `${w.brand || ""} ${w.model || ""}` },
                            { header: "Marca", mobile: "hidden", render: w => <span className="font-semibold">{w.brand}</span> },
                            { header: "Modelo", mobile: "hidden", render: w => w.model },
                            { header: "Ano", render: w => w.year },
                        ]}
                    />
                    :
                    <AdminEmptyState title="Nenhum relógio listado" />
            }
        </AdminCard>
    )
}
